import { createSlice } from '@reduxjs/toolkit';
import { SearchSortingSliceState } from '../../types';
import { getUrlSortOption } from '../../utils';

export const initialState: SearchSortingSliceState = {
  sortingList: [],
  currentSortOption: getUrlSortOption(),
};

const sortingSlice = createSlice({
  name: 'searchSorting',
  initialState,
  reducers: {
    setSortingList(state, { payload }) {
      state.sortingList = payload;
    },
    setCurrentSortOption(state, { payload }) {
      state.currentSortOption = payload;
    },
  },
});

export const { setSortingList, setCurrentSortOption } = sortingSlice.actions;
export default sortingSlice.reducer;
